import React, { useState } from 'react';
import { IMedia } from '../../common/types';
import { Typography } from '@unfold/typography';
import { LogosContainer } from './styled';
import { Logo } from './logo';
import { GridItem, Grid } from '@unfold/grid';
import { Button } from '@unfold/button';
import { Modal } from '@unfold/modal';
import { UploadModal } from '../../common/ui/upload-modal';
import { SectionWrapper } from '../../common/styled';

interface ILogosProps {
  logos: IMedia[];
  isLoading: boolean;
}

export const Logos: React.FC<ILogosProps> = ({ logos, isLoading }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleModalClose = (): void => {
    setModalOpen(false);
  };
  return (
    <SectionWrapper>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <>
          <Grid horizontalPadding={20}>
            <GridItem isWidthAuto>
              <Typography variant="H700">Logos</Typography>
            </GridItem>
            <GridItem isStretch>
              <Button
                uppercase={false}
                appearance="bordered"
                width={100}
                fontWeight={500}
                onClick={(): void => setModalOpen(true)}
              >
                Upload
              </Button>
            </GridItem>
          </Grid>

          <LogosContainer>
            {logos.map((logo) => (
              <Logo key={logo.uuid} logo={logo} />
            ))}
          </LogosContainer>

          <Modal
            isOpen={isModalOpen}
            onClose={handleModalClose}
            width={370}
            title="Upload Logos"
          >
            <UploadModal
              fileType="logo"
              onClose={handleModalClose}
            />
          </Modal>
        </>
      )}
    </SectionWrapper>
  );
};
